function onNavigation() {
  const menu = document.querySelector('.menuitem');
  const menuInner = menu.querySelector('.menu-inner');
  const menuArrow = menu.querySelector('.menu-arrow');
  const burger = document.querySelector('.burger');
  const closeIcons = document.querySelectorAll('.icon-close');

  const toggleMenu = () => {
    menu.classList.toggle('is-active');
    if (menu.classList.contains('is-active')) {
      menu.classList.add('is-first-level');
      document.body.classList.add('no-scroll');
    } else {
      menu.classList.remove('is-first-level', 'is-second-level');
      document.body.classList.remove('no-scroll');
    }
  };

  const closeMenu = () => {
    if (menu.classList.contains('is-active')) {
      toggleMenu();
      hideSubMenu();
    }
  };

  const showSubMenu = (children) => {
    const subMenu = children.querySelector('.submenu');
    subMenu.classList.add('is-active');
    subMenu.style.animation = 'slideLeft 0.35s ease forwards';
    menu.querySelector('.menu-header').classList.add('is-active');

    menu.classList.remove('is-first-level');
    menu.classList.add('is-second-level');
  };

  const hideSubMenu = () => {
    const subMenu = document.querySelector('.submenu.is-active');
    if (subMenu) {
      subMenu.style.animation = 'slideRight 0.35s ease forwards';
      setTimeout(() => {
        subMenu.classList.remove('is-active');
      }, 300);
    }

    menu.querySelector('.menu-header').classList.remove('is-active');

    menu.classList.remove('is-second-level');
    menu.classList.add('is-first-level');
  };

  const toggleSubMenu = (e) => {
    if (!menu.classList.contains('is-active')) {
      return;
    }
    const dropdown = e.target.closest('.menu-dropdown');
    if (dropdown) {
      showSubMenu(dropdown);
    }
  };

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 992 && menu.classList.contains('is-active')) {
      toggleMenu();
    }
  });

  burger.addEventListener('click', toggleMenu);
  menuArrow.addEventListener('click', hideSubMenu);
  menuInner.addEventListener('click', toggleSubMenu);
  closeIcons.forEach(icon => icon.addEventListener('click', closeMenu));
}

function onSubMenu() {
  const desktopBreakpoint = 992;

  function updateMenuBehavior() {
    if ($(window).width() >= desktopBreakpoint) {

      $('li.menu-item.menu-dropdown').off('click').on('click', function (event) {
        event.stopPropagation();

        $(this).toggleClass('submenu-active');
        $('li.menu-item.menu-dropdown').not(this).removeClass('submenu-active');

        if ($('.submenu-active').length > 0) {
          $('#header').addClass('active');
        } else {
          $('#header').removeClass('active');
        }
      });

      $(document).off('click.menu').on('click.menu', function () {
        $('li.menu-item.menu-dropdown').removeClass('submenu-active');
        $('#header').removeClass('active');
      });

      $('.submenu').off('click').on('click', function (event) {
        event.stopPropagation();
      });

    } else {
      $('li.menu-item.menu-dropdown').off('click');
      $(document).off('click.menu');
      $('.submenu').off('click');

      $('li.menu-item.menu-dropdown').removeClass('submenu-active');
      $('#header').removeClass('active');
    }
  }

  updateMenuBehavior();
  $(window).on('resize', updateMenuBehavior);
}

export { onNavigation, onSubMenu };


